import { FC } from "react";
import {
  Create,
  CreateProps,
  FormGroupContextProvider,
  FormWithRedirect,
  required,
  useCreate,
  useNotify,
  useRedirect,
} from "react-admin";

import CustomCard from "../../../components/CustomCard";
import CustomToolbar from "../../../components/CustomToolbar";
import FormWrapper from "../../../components/FormWrapper";
import ImageUploadInput from "../../../components/ImageUploadInput";
import Spacing from "../../../components/Spacing";
import useCurrentUser from "../../../hooks/useCurrentUser";
import useDisabledOnLoading from "../../../hooks/useDisabledOnLoading";
import { FormGroupNames } from "../../../types/reactAdmin.types";
import { AppResource } from "../../../types/resource.types";
import { validateFileSize } from "../../../utils/validators";
import useTrainersLocalizations from "./utils/useTrainersLocalizations";

const CustomForm: FC<any> = (props) => {
  const { user } = useCurrentUser();
  const redirect = useRedirect();
  const notify = useNotify();
  const [create, { loading }] = useCreate();

  const { disabledStyles } = useDisabledOnLoading(loading);
  const localizations = useTrainersLocalizations(props);

  const handleSubmit = async (data: any) => {
    create(
      AppResource.trainers,
      {
        values: {
          ...data,
        },
        user,
      },
      {
        onSuccess() {
          notify("Trainer has been created", "success");
          redirect(`/${AppResource.trainers}`);
        },
        onFailure(ex: any) {
          console.log(ex.message);
          notify("Error on creating trainer", "error");
        },
      }
    );
  };

  return (
    <FormWrapper>
      <FormGroupContextProvider name={FormGroupNames.trainersCreate}>
        <FormWithRedirect
          {...props}
          save={handleSubmit}
          render={(formProps) => {
            return (
              <form onSubmit={formProps.handleSubmit} style={disabledStyles}>
                <CustomCard title="Details">
                  <Spacing>
                    {localizations?.[0]}
                    {localizations?.[1]}
                  </Spacing>
                </CustomCard>

                <CustomCard title="Picture">
                  <ImageUploadInput source="picture" validate={[required(), validateFileSize("picture")]} />
                </CustomCard>

                <CustomCard title="Certificates">
                  <ImageUploadInput
                    source="certificates"
                    validate={[required(), validateFileSize("certificates")]}
                    multiple={true}
                  />
                </CustomCard>

                <CustomToolbar {...formProps} formName={FormGroupNames.trainersCreate} customErrors={{}} />
              </form>
            );
          }}
        />
      </FormGroupContextProvider>
    </FormWrapper>
  );
};

const TrainersCreate: FC<CreateProps> = (props) => {
  return (
    <Create {...props} component="section">
      <CustomForm />
    </Create>
  );
};

export default TrainersCreate;
